@if (error) {
<app-alert (close)="error = null" type="error" class="mt-3">{{
  error
}}</app-alert>
} @if (vehicle) { @if(isUserVehicle){
<div class="d-flex justify-content-end mt-2 mb-4">
  Status:
  <div class="ms-2 me-2">{{ utils.getStatus(vehicle.status) }}</div>
  <mat-icon class="{{ utils.getStatusColor(vehicle.status) }}">
    {{ utils.getStatusIcon(vehicle.status) }}
  </mat-icon>
</div>
}

<div class="mt-3 ms-3">
  <display-input title="Make" [value]="vehicle.manufacturer" />
  <display-input title="Model" [value]="vehicle.model" />
  <display-input title="Year" [value]="vehicle.year" />
  <display-input title="Color" [value]="vehicle.color" />
  <display-input title="Vin" [value]="vehicle.vin" />
  <display-input title="Registration Number" [value]="vehicle.registration" />
  <display-input title="Volume Capacity (cm³)" [value]="vehicle.volumeCapacity?.toString()" />
  <display-input title="Weight Capacity (kg)" [value]="vehicle.weightCapacity?.toString()" />
</div>

<div class="d-flex align-items-center justify-content-end mt-3">
  @if (loading) {
  <mat-progress-spinner mode="indeterminate" color="primary" diameter="30" />
  } @else if(isUserVehicle) {
  <div class="d-flex align-items-center">
    <button
      (click)="onDeclineClicked()"
      [disabled]="vehicle.status == 'declined'"
      mat-raised-button
      color="warn"
      class="me-3 px-4"
    >
      Decline
    </button>
    <button
      (click)="onApproveClicked()"
      [disabled]="vehicle.status == 'approved'"
      mat-raised-button
      class="px-4"
    >
      Approve
    </button>
  </div>
  }
</div>
}

<div class="d-flex justify-content-center align-items-center h-100">
  <div class="text-center">
    @if (!carTrackDriverId) {
    <div class="gray mb-3">No Car Track Profile</div>
    <button
      (click)="onCreateDriverProfileClicked()"
      mat-raised-button
      color="secondary"
      class="px-4"
    >
      Create Car Track Profile
    </button>
    } @else if (!vehicle) {
    <div class="gray mb-3">No Vehicle Assigned</div>
    <button
      (click)="onAssignDriverClicked()"
      mat-raised-button
      color="primary"
      class="px-4"
    >
      Assign Vehicle
    </button>
    }
  </div>
</div>
